<template>
        <div id='trainlist'>
              <NavTop title='培训列表' :islink='true' linkurl='/my'/>
              <div class='maincon'>
                  <div class="goodsitem" v-for="item in trainlist" :key="item.id">
                      <div class="goodsitem-row" @click='goDetail(item.id)'>
                        <div class="goodsitem-col1"><img :src='item.headimg'  class='headimg'/></div>
                        <div class="goodsitem-col2">
                            <div class="goodsitem-col2-line1">{{item.name}}</div>
                            <div class="goodsitem-col2-line2">时间:{{item.startdate}}-{{item.enddate}}</div>
                            <div class="goodsitem-col2-line2">地址:{{item.address}}</div>
                            <div class="goodsitem-col2-line3">
                                <div class="goodsprice"></div>
                                <div class="goodsnums">
                                    <div class="trainbtn bgred" v-if="item.trainstatus==2">
                                        <span>去报名</span> 
                                     </div>
                                    <div class="trainbtn bggrey" v-else>
                                       <span v-if="item.trainstatus==1">未开始</span> 
                                       <span v-else-if="item.trainstatus==3">已结束</span>
                                       <span v-else>已结束</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                  </div>
              </div>  
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  name: 'trainlist',
  data(){
    return {
        trainlist:[]
    }
  },
  created(){
    this.getList()
  },
  methods:{
    getList(){
       this.$post("/school/getTrainList",{}).then((data)=>{
           if(data.result.success){
               this.trainlist=data.result.info.trainlist
           }else{
               this.$toast(data.result.info)
           }
       })
    }, 
    goDetail(trainid){
       this.$go("/traindetail/"+trainid)
    } 
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#trainlist{background-color:#F6F6F6;min-height: 100vh;}
.maincon{display: flex;flex-flow: column nowrap;margin-bottom: 100px;padding: 0 0.25rem;}
.goodsitem{display: flex;background-color: #fff;margin-top: 0.25rem;height: 3.8rem;align-items:center;border:1px solid #e7e7e7;border-radius: 0.2rem;}
.goodsitem-row{display: flex;flex-flow: row nowrap;justify-content: flex-start;width:100%;height: 100%;}
.goodsitem-col1{flex:1.2;}
.goodsitem-col1 img{width:100%;}
.goodsitem-col2 {display: flex; flex-flow: column nowrap;text-align: left;width:100%;flex:3;padding:0.35rem 0.15rem 0 0.35rem;}
.goodsitem-col2-line1{font-size: 0.35rem;}
.goodsitem-col2-line2{font-size: 0.3rem;color:#5e5e5e;margin-top: 0.15rem;}
.goodsitem-col2-line3{margin-top: 0.1rem;display: flex;flex-flow: row nowrap;}
.goodsnums{margin-left: auto;margin-right:0.3rem;}
.goodsprice{color:#ff3600;font-size:0.4rem;display: flex;align-items: center;}
.bottomcon{display: flex;width:100%;background-color:#fff;height: 80px;position: fixed;left:0;bottom: 0;align-items: center;}
.bottomcon-left{display: flex;padding-left: 0.5rem;}
.goodswords{color:#333;font-size:0.35rem}
.bottomcon-right{margin-left: auto;padding-right: 0.3rem;}
.bottomcon-orderbtn{background-color:#ee0a24;color:#fff;height:1rem;width:3rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;}
.bottomcon-orderbtn-words{font-size:0.35rem;}
.headimg{width:100%;height:100%;border-top-left-radius: 0.2rem;border-bottom-left-radius: 0.2rem;}
.trainbtn{border-radius: 0.12rem;width:2rem;color:#fff;display: flex;flex-flow: row nowrap;justify-content: center;align-items: center;padding: 0.1rem;}
.bggrey{background-color: #999999;}
.bgred{background-color:#ee0a24;}
</style>


